import {
  jb_campaign_teaser_css_default
} from "./chunk.IEWMIBWR.js";
import {
  e
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  jbLinkClickedEventToJbTrackingEvent
} from "./chunk.TC6HXM2Y.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Spaceable
} from "./chunk.JI7MO3NT.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-campaign-teaser/jb-campaign-teaser.ts
var JbCampaignTeaser = class extends Spaceable(i) {
  constructor() {
    super(...arguments);
    this.description = "";
    this.forceHover = false;
    this.headline = "";
    this.languageBadge = "";
    this.subline = "";
  }
  _getContentSpacingProperties() {
    return { grid: true, colsMdUp: 10 };
  }
  _tracking(e2) {
    const interactionText = e2.detail.linkableComponent?.innerText ?? e2.detail.linkTag.href;
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e2, {
      component_name: "campaign-teaser",
      interaction_text: interactionText
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  render() {
    return b`
      <section>
        ${this.headline ? b`<jb-section-headline headline=${this.headline}></jb-section-headline>` : A}
        <div class="teaser-container">
          <div class=${e({ bg: true, hover: !!this.forceHover })}>
            <jb-anchor
              .ariaLabels=${{ label: this.subline }}
              .link=${this.button?.link}
              @jb-link:clicked=${this._tracking}
            >
              <jb-picture
                .alt=${this.backgroundImage?.alt}
                .imgData=${this.backgroundImage?.imgData}
                ?lazy=${this.backgroundImage?.lazy}
                fit="cover"
              ></jb-picture>
            </jb-anchor>
          </div>
          <div class="content">
            <div class="text-content">
              ${this.subline ? b`<jb-heading
                      offset=${this.headline ? 1 : 0}
                      variant="heading-xl"
                      >${this.subline}</jb-heading
                    >` : A}
              ${this.description ? b`<p class="description">${this.description}</p>` : A}
              ${this.languageBadge ? b`<p class="language-badge">${this.languageBadge}</p>` : A}
            </div>
            <div
              class="btn-panel"
              @mouseenter=${() => {
      this.forceHover = true;
    }}
              @mouseleave=${() => {
      this.forceHover = false;
    }}
              @jb-link:clicked=${this._tracking}
            >
              ${this.button?.text ? b`<jb-button-primary .link=${this.button.link}>${this.button.text}</jb-button-primary>` : A}
            </div>
          </div>
        </div>
      </section>
    `;
  }
};
JbCampaignTeaser.styles = [reset_css_default, jb_campaign_teaser_css_default];
__decorateClass([
  n({ type: Object })
], JbCampaignTeaser.prototype, "backgroundImage", 2);
__decorateClass([
  n({ type: Object })
], JbCampaignTeaser.prototype, "button", 2);
__decorateClass([
  n()
], JbCampaignTeaser.prototype, "description", 2);
__decorateClass([
  n({ type: Boolean })
], JbCampaignTeaser.prototype, "forceHover", 2);
__decorateClass([
  n({ reflect: true })
], JbCampaignTeaser.prototype, "headline", 2);
__decorateClass([
  n()
], JbCampaignTeaser.prototype, "languageBadge", 2);
__decorateClass([
  n()
], JbCampaignTeaser.prototype, "subline", 2);
JbCampaignTeaser = __decorateClass([
  customElement("jb-campaign-teaser")
], JbCampaignTeaser);

export {
  JbCampaignTeaser
};
